import { isBigScreen } from "constants/";
import React, { useState } from "react";
import useCopyText from "./useCopyText";
import { Share } from "react-native";
import useSendSMS from "./useSendSMS";

function useShare() {
  const [shareError, setShareError] = useState<any>();
  const { copyText, copied } = useCopyText();
  const sendSMS = useSendSMS();

  const doShareInAndroid = (message: string) => {
    // If running in Android WebView, convert the file content to a base64 string
    // and send it to the AndroidInterface for further handling.
    // @ts-ignore
    if (typeof window.AndroidInterface.sendFile === "function") {
      // @ts-ignore
      window.AndroidInterface.sendFile(
        btoa(message),
        message.slice(0, 100) + "...",
        "text/plain"
      );
    } else {
      throw new Error();
    }
  };

  const handleShare = (message: string) => {
    try {
      if (isBigScreen) {
        copyText(message);
        return;
      }
      // Webview inside Android does not have access to the native Share API
      // need to call custom code, see https://github.com/FanRally/fanrally-core/issues/888#issuecomment-1738339507
      if ("AndroidInterface" in window) {
        doShareInAndroid(message);
      } else {
        Share.share({
          message,
        });
      }
    } catch (error) {
      alert(error);
      // If Share doesn't work, fallback to sending SMS
      sendSMS(message);
      setShareError(error);
    }
  };
  return {
    handleShare,
    copied,
    shareError,
  };
}

export default useShare;
